import { Controller } from '@hotwired/stimulus'
import { turboRequest } from '../../helpers/turbo_helper'

export default class extends Controller {

  static values = {
    url: String
  }

  connect() {}

  turboCall(event) {
    let params = new URLSearchParams()
    params.append(event.target.name, event.target.value)

    turboRequest(`${this.urlValue}.turbo_stream?${params}`)
  }
}
